import React from 'react'
import { Modal, App } from 'antd'
import {useBusinessNumDelMutation,} from '../../store/ReactWebSiteApi';

function LedgerDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useBusinessNumDelMutation()   
    return (
        <>
            {
                (!props.ebn_audit_ctime && props.ebn_state==='2') && <a onClick={() => {
                    confirm({
                        title: '确定删除？',
                        content: props.ebn_team_num,
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                ebn_id:props.ebn_id,
                                ebn_state:'2'
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.info('删除成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        },
                        onCancel() {
                            console.log('Cancel');
                        },
                    }); 
                }}>删除</a>
            }
            {props.ebn_state==='1' &&<a onClick={() => {
                    confirm({
                        title: '确定取消删除？',
                        content: props.ebn_team_num,
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                ebn_id:props.ebn_id,
                                ebn_state:'1'
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.info('取消删除成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('取消删除失败！'+res.data.Message)
                                }
                            })
                        },
                        onCancel() {
                            console.log('Cancel');
                        },
                    }); 
                }}>取消删除</a>}
        </>
    )
}

export default LedgerDel